export default "__VITE_ASSET__rxGk_7RJ__"